export const formatPrice = (number) => {
  const newNumber = Intl.NumberFormat('en-TN', {
    style: 'currency',
    currency: 'TND',
    minimumFractionDigits: 0
  }).format(number);
  return newNumber;
};

export const getUniqueValues = (data, type) => {
  let unique = data.map((item) => item[type]);

  if (type === 'colors') {
    unique = unique.flat().map(color => {
      if (typeof color === 'object' && color !== null) {
        return color.code;
      }
      return color;
    });
  }

  // Normalize category names to avoid duplicates like 'kitchen' and 'Kitchen'
  if (type === 'category') {
    unique = unique.map(cat => {
      if (typeof cat === 'string') {
        // Capitalize first letter, lowercase rest
        return cat.charAt(0).toUpperCase() + cat.slice(1).toLowerCase();
      }
      return cat;
    });
  }

  unique = new Set(unique);
  return ['all', ...unique];
};

// axios only populates error.response when the server actually returned an
// HTTP response. A network-level failure (server unreachable, offline, CORS
// block, timeout) leaves it undefined — reading .data off it crashes instead
// of surfacing an error message.
export const getApiError = (error) => {
  if (error.response && error.response.data) {
    return error.response.data;
  }
  return {
    success: false,
    message: 'Network error — please check your connection and try again.',
  };
};

export const getSecureUrl = (url) => {
  if (url && url.startsWith('http://')) {
    return url.replace('http://', 'https://');
  }
  return url;
};

// Ask Cloudinary for a resized/auto-compressed version instead of shipping
// the full-resolution original for a product card/list thumbnail.
export const getThumbnailUrl = (url, width = 500) => {
  const secureUrl = getSecureUrl(url);
  if (!secureUrl || !secureUrl.includes('/upload/')) {
    return secureUrl;
  }
  return secureUrl.replace('/upload/', `/upload/w_${width},q_auto,f_auto/`);
};

export const checkObjectProperties = (obj = {}) => {
  // Return true when any required property is missing/empty (used to determine
  // whether the shipping form still needs editing)
  if (!obj || typeof obj !== 'object') return true;
  const values = Object.values(obj);
  for (const v of values) {
    if (v === null || v === undefined) return true;
    if (typeof v === 'string' && v.trim() === '') return true;
  }
  return false;
};

export const getOrderStatusColor = (status) => {
  if (status === 'processing') {
    return 'var(--clr-orange)';
  }
  if (status === 'rejected') {
    return 'var(--clr-red-dark)';
  }
  return 'var(--clr-green-dark)';
};

export const formatAddress = (data) => {
  const { address, city, state, country, pinCode } = data;
  return `${address}, ${city}, ${state} - ${pinCode}, ${country}`;
};

// Detect if text is predominantly Arabic (RTL) or Latin (LTR)
export const isArabicText = (text) => {
  if (!text || typeof text !== 'string') return false;
  // Remove HTML tags to check the actual text content
  const plainText = text.replace(/<[^>]*>/g, '');
  // Count Arabic characters (Arabic Unicode range)
  const arabicChars = plainText.match(/[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF]/g);
  const arabicCount = arabicChars ? arabicChars.length : 0;
  // Count Latin characters
  const latinChars = plainText.match(/[a-zA-ZÀ-ÿ]/g);
  const latinCount = latinChars ? latinChars.length : 0;
  // If more Arabic than Latin, it's Arabic text
  return arabicCount > latinCount;
};

// Get the numeric shipping cost from a product's shipping field.
// Handles both the legacy boolean format and the new numeric format.
// - number (e.g. 8): use as-is
// - boolean true (legacy): default to 8 TND
// - falsy (false, 0, null, undefined): returns 0 (free shipping)
export const getShippingCost = (shipping) => {
  if (typeof shipping === 'number') return shipping;
  if (shipping === true) return 8;
  return 0;
};
